<script lang="ts">
	// Renders the Toaster inside a popover, placing it in the browser top layer so toasts
	// appear above native <dialog> backdrops regardless of z-index.
	import { onMount } from 'svelte';
	import { Toaster } from 'svelte-sonner';

	let el: HTMLDivElement;

	onMount(() => {
		el?.showPopover();

		// Re-promote to the top of the top layer whenever a dialog opens,
		// since showModal() stacks above any previously promoted popover.
		const observer = new MutationObserver((mutations) => {
			for (const m of mutations) {
				if (m.target instanceof HTMLDialogElement && m.oldValue === null) {
					el?.hidePopover();
					el?.showPopover();
					break;
				}
			}
		});
		observer.observe(document.body, {
			subtree: true,
			attributeFilter: ['open'],
			attributeOldValue: true
		});

		return () => observer.disconnect();
	});
</script>

<div
	popover="manual"
	bind:this={el}
	class="bg-transparent border-0 p-0 m-0 max-w-none max-h-none w-full h-full overflow-visible pointer-events-none"
>
	<Toaster theme="light" richColors position="top-right" />
</div>
